import React, { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import { loginRequest } from "../services/msalConfig";
import { CheckSSOUser, checkUserExists, fetchCompanyloged } from "../services/apiService";
import toast from "react-hot-toast";
import { InteractionStatus } from "@azure/msal-browser";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [companies, setCompanies] = useState([]);
  const [temp, setTemp] = useState({ companyCode: "" });
  const navigate = useNavigate();
  const { instance, inProgress } = useMsal();

  useEffect(() => {
    const loadCompany = async () => {
      try {
        const data = await fetchCompanyloged();
        setCompanies(data);
      } catch (err) {
        console.error("Failed to fetch companies", err);
      }
    };
    loadCompany();
  }, []);

  const handleTempChange = (e) => {
    setTemp((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

    const isSafari = () => {
    const ua = navigator.userAgent;
    // Detects Safari on all Apple devices (macOS, iOS, iPad)
    // Safari UA contains "Safari" but NOT "Chrome", "CriOS", "FxiOS", "EdgiOS"
    return /Safari/.test(ua) && !/Chrome/.test(ua) && !/CriOS/.test(ua) && !/FxiOS/.test(ua) && !/Edg/.test(ua);
  };

 const handleLogin = async () => {
  // Prevent multiple logins
  if (inProgress !== InteractionStatus.None) {
    toast("Login is already in progress. Please wait.", { icon: "⏳" });
    return;
  }

  try {
    let loginResponse;

    if (isSafari()) {
      // Safari (macOS, iOS, iPad): use redirect — Safari blocks popups
      await instance.loginRedirect(loginRequest);
      return;
    }

    // Desktop / non-iOS: try popup first, fall back to redirect if blocked
    try {
      loginResponse = await instance.loginPopup(loginRequest);
      instance.setActiveAccount(loginResponse.account);
    } catch (popupErr) {
      if (popupErr.errorCode === "popup_window_error" || popupErr.errorCode === "empty_window_error") {
        // Popup was blocked — fall back to redirect
        toast("Popup blocked. Redirecting to Microsoft login...", { icon: "🔄" });
        await instance.loginRedirect(loginRequest);
        return;
      }
      throw popupErr;
    }

    const account = loginResponse.account;

    if (!account?.username) {
      toast.error("No Microsoft account found.");
      return;
    }

    const email = account.username;

    // Call backend to check user
    const response = await CheckSSOUser(email);

    if (response && response.token) {
      localStorage.setItem("authToken", response.token);
      localStorage.setItem("isAuthenticated", "true");
      toast.success("Login successful!");
      window.location.href = "/";
    } else {
      toast.error("Invalid email or user not registered.");
    }
  } catch (err) {
    console.error("Login failed", err);
    if (err.errorCode === "user_cancelled") {
      toast.error("Login cancelled.");
    } else {
      toast.error("Login failed. Please try again.");
    }
  }
};


  const handleLoginSuccess = (token) => {
    setError("");
    localStorage.setItem("authToken", token);
    localStorage.setItem("isAuthenticated", "true");
    window.location.href = "/";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast.error("Please fill in all fields.");
      setSuccess("");
      return;
    }
    try {
      const response = await checkUserExists(email, password, temp.companyCode);
      if (response && response.token) {
        handleLoginSuccess(response.token);
      } else {
        setError("Invalid email or password.");
        setSuccess("");
      }
    } catch (err) {
      toast.error("Something went wrong while logging in.");
      setSuccess("");
    }
  };

  return (
    <div className="flex flex-col min-h-screen w-full bg-white relative">
      {/* Background Image */}
      <div className="relative w-full h-64 sm:h-72 md:h-80 lg:h-96 bg-primary-500">
        <img src="bg1.png" alt="Header Background" className="w-full h-full object-cover" />
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center flex flex-col items-center justify-center px-4">
          {/* <h1 className="text-primary-600 font-semibold text-lg sm:text-xl md:text-2xl lg:text-3xl">
            Sign In
          </h1>
          <p className="text-primary-600 text-xs sm:text-sm md:text-base mt-1 sm:mt-2">
            Sign in using your email or Windows Authentication to access AHC Recruiter services.
          </p> */}
        </div>


 <div className="flex flex-grow items-center justify-center px-4 -mt-16 sm:-mt-20 md:-mt-24 lg:-mt-28 relative">
        <div className="w-full max-w-md sm:max-w-lg md:max-w-xl lg:max-w-2xl bg-white p-4 sm:p-6 md:p-8 bg-white rounded-2xl  filter drop-shadow-[0_5px_30px_rgba(10,60,96,0.10)]">

            <h1 className="text-primary font-semibold text-lg sm:text-xl md:text-2xl lg:text-3xl">
            Sign In
          </h1>
          <p className="text-primary text-xs sm:text-sm md:text-base mt-1 sm:mt-2">
            Sign in using your email or Windows Authentication to access AHC Recruiter services.
          </p>


          <div className="flex justify-center mb-4 sm:mb-6">
            <img src="logo.svg" alt="Company Logo" className="h-10 sm:h-12 md:h-12 object-contain" />
          </div>
          

          {error && <div className="text-red-600 text-sm mb-2">{error}</div>}
          {success && <div className="text-green-600 text-sm mb-2">{success}</div>}

          <form onSubmit={handleSubmit} className="space-y-3 sm:space-y-4">
            {/* Company */}
            <div>
              <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-1">
                Company
              </label>
              <select
                name="companyCode"
                value={temp.companyCode}
                onChange={handleTempChange}
                className="w-full border border-gray-300 rounded-md px-3 py-2 sm:py-2.5 focus:outline-none focus:ring-1 focus:ring-primary-800/50 text-sm sm:text-base"
                required
              >
                <option value="">Select Company</option>
                {companies.map((c) => (
                  <option key={c.companyCode} value={c.companyCode}>
                    {c.companyName}
                  </option>
                ))}
              </select>
            </div>

            {/* Email */}
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                Email
              </label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                className="w-full border border-gray-300 rounded-md px-3 py-2 sm:py-2.5 focus:outline-none focus:ring-1 focus:ring-primary-800/50 text-sm sm:text-base"
                required
              />
            </div>

            {/* Password */}
            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
                Password
              </label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                className="w-full border border-gray-300 rounded-md px-3 py-2 sm:py-2.5 focus:outline-none focus:ring-1 focus:ring-primary-800/50 text-sm sm:text-base"
                required
              />
              <div className="text-right mt-1">
                <a href="/forgot-password" className="text-xs sm:text-sm text-primary-800 underline hover:text-[#6f6246]">
                  Forgot Password?
                </a>
              </div>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              className="w-full bg-primary-800 text-white py-2 sm:py-2.5 rounded-md hover:bg-primary-800/70 text-sm sm:text-base transition"
            >
              Login
            </button>
          </form>

          {/* Divider */}
          <div className="relative my-3 sm:my-4">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-gray-300" />
            </div>
            <div className="relative flex justify-center text-xs sm:text-sm text-gray-500">
              <span className="bg-white px-2">or</span>
            </div>
          </div>

          {/* Microsoft Login */}
          <div className="text-center">
            <p className="text-gray-700 text-xs sm:text-sm mb-2">
              Click 'Windows Authentication' to access the portal.
            </p>
            <button onClick={handleLogin}>
              <img src="login.svg" alt="Windows Authentication" className="mx-auto h-8 sm:h-10" />
            </button>
          </div>
        </div>
      </div>


      </div>

      {/* Login Form */}
     
    </div>
  );
};

export default LoginPage;
